<div>
    <div class="p-b-24 font-c1 text-center">
        Enviá este Givi como regalo ingresando el número de teléfono de la persona a la que se lo querés regalar.
    </div>
    <div>
        <form class="form-horizontal form-material" [formGroup]="formGroup" (ngSubmit)="onSubmit()" #formDir="ngForm">

            <div class="form-group">
                <app-phone-input [formGroup]="formGroup" [country]="sale?.country" [label]="'Teléfono celular'" (change)="onSearchPhone(1)"></app-phone-input>

                <!-- Phone without account -->
                <div class="font-c1" *ngIf="customerReceiving == null && !validCustomerReceiving">
                    No tiene cuenta en Givi.
                </div>

                <!-- Phone with account -->
                <p class="font-c1" *ngIf="validCustomerReceiving">Este número pertenece: 
                    <b *ngIf="customerReceiving?.name.length > 1">{{customerReceiving?.name }} {{customerReceiving?.lastName?.charAt(0)}}</b>
                    <b *ngIf="customerReceiving?.name.length  <= 1"> Pendiente de completar perfil </b>
                </p>
            </div>

            <!-- Button submit -->
            <div class="d-flex-center">
                <button *ngIf="!validCustomerReceiving && showBtn == 1" class="btn btn-dark w-100" type="button" [disabled]="formGroup.invalid" (click)="onSearchPhone(2)"
                style="padding: 8px 40px; text-transform: none; border-radius: 25px;">Buscar</button>
                <button *ngIf="validCustomerReceiving && showBtn == 2" class="btn btn-dark w-100" type="submit" [disabled]="formGroup.invalid"
                style="padding: 8px 40px; text-transform: none; border-radius: 25px;">Enviar</button>
                <button *ngIf="customerReceiving == null && !validCustomerReceiving && showBtn == 3" class="btn btn-dark w-100" (click)="onSendLink()"
                style="padding: 8px 40px; text-transform: none; border-radius: 25px;">Enviar por link</button>
            </div>
        </form>
    </div>
</div>


<ng-template #showConfirmationSendGivi let-modal>
    <div class="modal-body">
        <div class="d-flex justify-content-center mt-3">
            <div class="container m-b-24">
                <div class="row" style="background-color: #F5F5F7; padding: 15px; border-radius: 9px;">
                    <div [ngClass]="sale.tickets.length > 0 ? 'col-6 p-0' : 'col-5'" 
                        [ngStyle]="sale.coupons.length > 0 ? {'padding-left': '0px'} : {}"><!-- More space for tickets -->
                        <div class="text-center">
                            <div class="m-t-10">
                                <img [src]="sale.productURL" width="73px" *ngIf="sale.giftcards.length > 0">
                                <div *ngIf="sale.coupons.length > 0" class="w-100">
                                    <div class="img-container d-flex align-items-center">
                                        <div class="img-bg d-flex">
                                            <img src="assets/images/GiviBITFormat3.png" style="height: 100%;">
                                            <img [src]="sale.productURL" alt="Carga tu foto aquí" class="img-coupon"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="image-container" *ngIf="sale.tickets.length > 0">
                                    <img src="{{sale.ticket.eventObj.logoUrl}}"/>
                                    <div class="decorative-dots-left"></div>
                                    <div class="decorative-dots-right"></div>
                                </div>
                            </div>
                            <div class="m-t-8" *ngIf="sale.giftcards.length > 0">
                                <span class="font-bold">{{sale.total | currency: sale?.currencySymbol : 'symbol': '1.0'}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- Show for giftcards and coupons -->
                    <div *ngIf="sale.tickets.length == 0" class="col-2 text-center d-flex align-items-center" style="padding-top: 5%;">
                        <i class="mdi mdi-chevron-double-right  mdi-36px"></i>
                    </div>
                    <div class="d-flex-center align-items-center" [ngClass]="sale.tickets.length > 0 ? 'col-6' : 'col-5'"><!-- 6 for tickets -->
                        <div *ngIf="sale.tickets.length > 0" class="text-center d-flex align-items-center" style="padding-top: 5%;">
                            <i class="mdi mdi-chevron-double-right  mdi-36px"></i>
                        </div>
                        <div class="text-center">
                            <div>
                                <app-img-round [src]="customerReceiving.logoURL" [width]="55"></app-img-round>
                            </div>
                            <div class="m-t-8">
                                <span class="font-bold">
                                    {{customerReceiving.name }} {{customerReceiving.lastName.charAt(0)}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex m-b-20 justify-content-center">
            <p class="font-c1" *ngIf="validCustomerReceiving">
                El Givi se va regalar a 
                <b>{{customerReceiving.name}} {{customerReceiving.lastName.charAt(0)}}</b> 
                y automáticamente se le va a notificar. El Givi va a desaparecer de tu cuenta.
        </div>
        <div class="d-flex-center">
            <div>
                <button class="btn-dark-custom" (click)="updateTransaction()">Confirmar</button>
                <div class="text-muted d-flex-center pt-2" (click)="closeModal()">Cancelar</div>
            </div> 
        </div>
    </div>
</ng-template>